import { render, staticRenderFns } from "./editDiscountTicketDetail.vue?vue&type=template&id=48a29111&scoped=true"
import script from "./editDiscountTicketDetail.vue?vue&type=script&lang=js"
export * from "./editDiscountTicketDetail.vue?vue&type=script&lang=js"
import style0 from "./editDiscountTicketDetail.vue?vue&type=style&index=0&id=48a29111&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a29111",
  null
  
)

export default component.exports